if (!customElements.get('xo-count-up')) {
  class XoCountUp extends HTMLElement {
    connectedCallback() {
      this._observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            this._observer.disconnect();
            this._animate();
          }
        },
        { threshold: 0.5 }
      );
      this._observer.observe(this);
    }

    _animate() {
      const start    = parseFloat(this.dataset.start    ?? 0);
      const end      = parseFloat(this.dataset.end      ?? 100);
      const duration = parseInt(this.dataset.duration   ?? 2000, 10);
      const t0       = performance.now();

      const tick = (now) => {
        const p      = Math.min((now - t0) / duration, 1);
        const eased  = 1 - Math.pow(1 - p, 3); // ease-out cubic
        const value  = Math.round(start + (end - start) * eased);
        this.textContent = value.toLocaleString();
        if (p < 1) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    }
  }

  customElements.define('xo-count-up', XoCountUp);
}
